import React from 'react';
import '../../App.css';
import PodStatementForm from '../PodStatementForm';

function PodStatementPage({ sessionObject, setGlobalOverlay }) {
  if(!sessionObject.sessionVariables["modules"].includes("pod_statement")){
    return;}
  return (
    <div className="page-mr">
      <PodStatementForm 
        sessionObject={sessionObject}
        setGlobalOverlay={setGlobalOverlay}
      />
    </div>
  );
}

export default PodStatementPage;